import React, { SVGAttributes } from 'react'

const ArrowCheck: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="#1373E5" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3091 5.19052C17.6641 5.54554 17.6641 6.12115 17.3091 6.47617L8.14241 15.6428C7.97192 15.8133 7.74069 15.9091 7.49959 15.9091C7.25848 15.9091 7.02725 15.8133 6.85676 15.6428L2.69009 11.4762C2.33507 11.1211 2.33507 10.5455 2.69009 10.1905C3.04512 9.8355 3.62072 9.8355 3.97574 10.1905L7.49959 13.7144L16.0234 5.19052C16.3784 4.8355 16.9541 4.8355 17.3091 5.19052Z"
    />
  </svg>
)

export default ArrowCheck
